module.exports = __webpack_public_path__ + "img/W-S19.60606673.jpg";